import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/soluciones/tecnologia-aprendizaje/vigia")({
  head: () => ({
    meta: [
      { title: "VigIA | Tecnología de Aprendizaje | Mine Class" },
      {
        name: "description",
        content:
          "VigIA: inteligencia artificial que valida documentos de acreditación minera, detecta inconsistencias y anticipa riesgos.",
      },
      { property: "og:title", content: "VigIA | Mine Class" },
      { property: "og:description", content: "IA especializada en validación documental para minería: detecta inconsistencias y anticipa riesgos de acreditación." },
      { property: "og:url", content: "https://mine-class.com/soluciones/tecnologia-aprendizaje/vigia" },
      { property: "og:type", content: "website" },
    ],
    links: [{ rel: "canonical", href: "https://mine-class.com/soluciones/tecnologia-aprendizaje/vigia" }],
  }),
  component: VigiaContent,
});

function VigiaContent() {
  return (
    <article className="space-y-6 text-[var(--color-on-surface-variant)] text-base md:text-lg leading-relaxed">
      <div>
        <span className="text-[10px] uppercase tracking-widest font-bold text-[var(--color-brand-coral)]">
          IA de validación documental
        </span>
        <h2 className="text-2xl md:text-3xl font-bold text-[var(--color-brand-purple)] mt-1">VigIA</h2>
      </div>

      <p>
        Inteligencia artificial especializada en validación documental para minería. VigIA valida la
        consistencia, pertinencia e integridad de los documentos que componen los procesos de acreditación
        y la carpeta de arranque, detectando inconsistencias, documentos inválidos y posibles riesgos
        antes de que impacten la operación.
      </p>
      <p>
        A diferencia de los sistemas tradicionales basados en reglas rígidas, VigIA comprende el contexto
        de cada documento: automatiza hasta el <strong>95% de las validaciones</strong>, derivando a
        revisión humana únicamente los casos que realmente lo requieren.
      </p>
      <p>
        Permite validar de acuerdo a reglas de negocio personalizables por cada empresa, adaptándose a los
        criterios y estándares específicos de cada operación minera.
      </p>

      <div className="flex flex-wrap gap-2 pt-2">
        {["95% automatización", "Contexto documental", "Reglas custom", "Anti-riesgo"].map((f) => (
          <span
            key={f}
            className="inline-flex items-center gap-1 px-2.5 py-1 rounded-full bg-[var(--color-brand-coral)]/10 text-[var(--color-brand-coral)] text-[11px] font-semibold"
          >
            <span className="material-symbols-outlined text-[13px]">check</span>
            {f}
          </span>
        ))}
      </div>

      <div className="pt-4">
        <Link
          to="/contacto"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-[var(--color-brand-coral)] text-white text-xs font-bold uppercase tracking-widest rounded-full hover:bg-[var(--color-brand-purple)] transition-colors"
        >
          Cotizar Solución
          <span className="material-symbols-outlined text-base">arrow_forward</span>
        </Link>
      </div>
    </article>
  );
}
